import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';
import { renderField, renderSelect, renderRadio, validate } from '../../helpers/validation.helper';
import { connect } from 'react-redux';
import moment from 'moment';
import {isEmpty} from '../../helpers/general.helper';
import { getUserDetails } from '../../actions/profile.actions';

const EditUserDetailsForm  = (props) => {
        const dt = new Date();
        const currYear = dt.getFullYear();
        const { handleSubmit, getDropdownValues, getMonths} = props;
        return (
            <div>
                <div className="edit-user-details-page">
                    <div className="row">
                        <div className="col-lg-12">
                                {/*<div className="col-lg-3">
                                    <Uploader />
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <img src={profileImg} className={"default-img-register mx-auto db"} alt={'Imagine profil'}/>
                                        </div>
                                    </div>
                                    <div className="row text-center">
                                        <div className="col-lg-12">
                                            <span className="upload-photo">Incarca o fotografie de profil</span>
                                        </div>
                                    </div>
                                </div>*/}
                                <div className="col-lg-12">
                                    <div className="edit-profile-item-header">
                                        <span className="profile-favorite">{props.initialValues.title}</span>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <Field
                                                    id="firstName"
                                                    name="first_name"
                                                    type="text"
                                                    placeholder="Nume"
                                                    component={renderField}
                                                />
                                            </div>
                                            <div className="col-lg-12">
                                                <Field
                                                    id="lastName"
                                                    name="last_name"
                                                    type="text"
                                                    placeholder="Prenume"
                                                    component={renderField}
                                                />
                                            </div>
                                            <div className="col-lg-12">
                                                <Field
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    placeholder="Email"
                                                    component={renderField}
                                                />
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <span className="dob-txt float-left db">Data nașterii</span>
                                                    </div>
                                                </div>

                                                <Field
                                                    className={'float-left'}
                                                    name="month"
                                                    component={renderSelect}>
                                                    <option value={props.initialValues.month}>{props.initialValues.month}</option>
                                                    { getMonths() }
                                                </Field>

                                                <Field
                                                    className={'float-left'}
                                                    name="day"
                                                    component={renderSelect}>
                                                    <option value={props.initialValues.day}>{props.initialValues.day}</option>
                                                    { getDropdownValues(1, 31) }
                                                </Field>

                                                <Field
                                                    className={'float-left'}
                                                    name="year"
                                                    component={renderSelect}>
                                                    <option value={props.initialValues.year}>{props.initialValues.year}</option>
                                                    { getDropdownValues(1900, currYear) }
                                                </Field>
                                            </div>
                                        </div>
                                        <Button className="save-button" type="submit">Salvează</Button>
                                    </form>
                                </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }

const form = reduxForm({
    form: 'editUserDetailsForm', // a unique identifier for this form,
    validate: validate('registerForm'),
    enableReinitialize: true
})

export default form(EditUserDetailsForm);
    



// WEBPACK FOOTER //
// ./src/SHARED/components/editUserDetails/editUserDetailsForm.js